var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"landing-page"},[_c('landing-header'),_c('landing-services')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }